import { render, staticRenderFns } from "./funes_M_datos.vue?vue&type=template&id=95699b7a"
import script from "./funes_M_datos.vue?vue&type=script&lang=js"
export * from "./funes_M_datos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports